import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OperatorGroupMembershipDto } from '../../../../../api/gen/model/operatorGroupMembershipDto';

@Component({
  selector: 'app-group-member-item',
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './group-member-item.component.html',
  styleUrl: './group-member-item.component.scss'
})
export class GroupMemberItemComponent {
  @Input() membership!: OperatorGroupMembershipDto;
  @Input() isRemoving = false;
  @Output() remove = new EventEmitter<OperatorGroupMembershipDto>();

  get fullName(): string {
    const op = this.membership.operator;
    return [op?.firstName, op?.lastName].filter(Boolean).join(' ') || 'Unknown';
  }

  get email(): string {
    return this.membership.operator?.email ?? '';
  }

  onRemove(): void {
    this.remove.emit(this.membership);
  }
}
